// extracted by mini-css-extract-plugin
export var section = "styles-module--section--763eU";
export var sectionContainer = "styles-module--sectionContainer--2wYIy";
export var container = "styles-module--container--2bxwA";
export var contentContainer = "styles-module--contentContainer--2b8wL";
export var stat = "styles-module--stat--3yIqJ";
export var subtitle = "styles-module--subtitle--S4CsI";